import { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import {
    addFormData
} from "../redux/index";
import { routeConstants } from "../constants/index";


const useForm = (callback, validate) => {
    const dispatch = useDispatch();
    const formData = useSelector(state => state.formReducer.formData);
    const nextPage = useSelector(state => state.navigationReducer.nextPage)
    const queryString = useSelector(state => state.queryStringReducer.queryString)
    const [values, setValues] = useState({});
    const [errors, setErrors] = useState({});
    const registrations = useRef({})
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(async () => {
        if (Object.keys(errors).length === 0 && isSubmitting) {
            //Set infomation for backend to pick up
            let v = values;

            if (!formData.HouseNumber || !formData.PostNumber || !formData.StreetName) {
                await addDAWAAdress(v)
            }

            v['Segment'] = queryString;
            v['PhoneNumber'] = v['PhoneNumber'].replace(/ */g, '');
            v['PhoneNumber'] = v['PhoneNumber'].replace(/\+45/g, '')
            v['PhoneNumber'] = v['PhoneNumber'].replace(/[\(\)]/g, "")

            v.reCaptchaToken = await window.grecaptcha.execute('6LdOD7oaAAAAAJykG6pl04WDLNG782Gqks3RcaGl', {action: 'submit'})
            dispatch(addFormData(v));

            sessionStorage.setItem('inboundData', JSON.stringify(v))   
            //-----------------------------------------------------------//

            callback();
        }
    }, [errors])

    useEffect(() => {
        if (typeof formData !== 'undefined') {
            setValues(formData);
        }
    }, [])

    const formatFullNameValue = (fullName) => {
        if (fullName && (fullName.match(/ /g) || []).length > 0) {
            const strings = fullName.split(' ');
            const lastName = strings[strings.length - 1];
            strings.pop();
            const firstName = strings.join(' ')

            setValues(values => ({
                ...values,
                FirstName: firstName,
                LastName: lastName
            }))
        } else {
            setValues(values => ({
                ...values,
                FirstName: fullName,
                LastName: fullName
            }))
        }

    }

    // Helper function to verify if a adress was looked up in DAWA and if not do so
    const addDAWAAdress = async (formData) => {
        try {
            let response = await fetch(`https://dawa.aws.dk/autocomplete?q=${formData.Address}&type=adresse&caretpos=15&supplerendebynavn=true&stormodtagerpostnumre=true&multilinje=true&fuzzy=`)
            let results = await response.json()
            let result = results[0]

            //ToDo refactor to remove doublicated mapping from labelledInputValidateDawa getSelectedAddressValues()
            if (result) {
                formData.PostNumber = result.data.postnr
                formData.StreetName = result.data.adresseringsvejnavn
                formData.HouseNumber = result.data.husnr.replace(/[a-zA-Z]/g, '')
                formData.HouseLetter = result.data.husnr.replace(/[0-9]/g, '')
                formData.Floor = result.data.etage && result.data.etage.length === 1 ? `0${result.data.etage}` : result.data.etage
                formData.SideDoor = resolveSideDoor(result.data.dør)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const resolveSideDoor = (value) => {
        if(value == null || isNaN(value)){
            return value
        }

        if(value.length === 1){
            return `000${value}`
        }

        if(value.length === 2){
            return `00${value}`
        }

        if(value.length === 3){
            return `0${value}`
        }
    }

    //For backend to know if "getOffer" or "bookMeeting" flow
    const addOperationKvp = () => {
        let operation = '';

        switch (nextPage) {
            case routeConstants.BookMeetingModal:
                operation = "bookMeeting"
                break;
            case routeConstants.UploadPolicyModal:
                operation = "getOffer"
                break;
        }

        setValues(values => ({
            ...values,
            Operation: operation
        }))
    }

    const handleSubmit = (event) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        };
          
        addOperationKvp();
        formatFullNameValue(values["FullName"]);
        setErrors(validate(values, registrations.current));
        setIsSubmitting(true);
    };

    const handleChange = (event) => {
        //event.persist();
        const { name, value, type, checked } = event.target;

        setValues(values => ({
            ...values,
            [name]: type === ('checkbox') ? checked : value,
        }))

    };

    const register = (name, obj) => {
        if (obj === null) {
            registrations.current = {}
        }
        else if (obj !== undefined ) {
            registrations.current[name] = obj
        }
    }

    return {
        handleSubmit,
        handleChange,
        register,
        values,
        errors
    };
};

export default useForm